export default __webpack_public_path__ + "static/media/highlight-2-new.8baa30b2.png";